// extracted by mini-css-extract-plugin
export var container = "_3n-1";
export var editor = "_3n-2";
export var resizable = "_3n-3";
export var wrapper = "_3n-0";